var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c(
              "el-form",
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { no: "booking", disabled: _vm.readonly },
                    model: {
                      value: _vm.form.booking,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "booking", $$v)
                      },
                      expression: "form.booking"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Booking")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "customs", disabled: _vm.readonly },
                    on: {
                      change: function(val) {
                        _vm.form.customsBroker = val
                          ? _vm.form.customsBroker
                          : 0
                        _vm.form.customsDeclarationType = val
                          ? _vm.form.customsDeclarationType
                          : -1
                      }
                    },
                    model: {
                      value: _vm.form.customs,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "customs", $$v)
                      },
                      expression: "form.customs"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclaration")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { disabled: _vm.readonly, no: "isInsure" },
                    model: {
                      value: _vm.form.insure,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "insure", $$v)
                      },
                      expression: "form.insure"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")) + " ")]
                ),
                _vm.isBookingNew && _vm.isFba
                  ? _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "destinationPortService" },
                        model: {
                          value: _vm.form.destinationPortService,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "destinationPortService", $$v)
                          },
                          expression: "form.destinationPortService"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.PortOfDestinationServices"))
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.viewSource === "bookingWorkspace"
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_insurance_toInsure"],
                            expression: "['button_insurance_toInsure']"
                          }
                        ],
                        staticStyle: { "margin-left": "20px" },
                        attrs: {
                          no: "Insure",
                          disabled: _vm.isEdit,
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pm.toInsure()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                    )
                  : _vm._e(),
                !_vm.isFba
                  ? _c("span", { staticStyle: { "margin-left": "20px" } }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessType")))
                    ])
                  : _vm._e(),
                !_vm.isFba
                  ? _c(
                      "el-radio-group",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { no: "lob", disabled: _vm.readonly },
                        on: { change: _vm.lobChangeHandler },
                        model: {
                          value: _vm.form.lob,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "lob", $$v)
                          },
                          expression: "form.lob"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { no: "RE", label: "RE" } }, [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Export")))
                        ]),
                        _c(
                          "el-radio",
                          {
                            staticStyle: { "margin-left": "-20px" },
                            attrs: { no: "RI", label: "RI" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_JobTypeImport"))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticStyle: { display: "flex" } }, [
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "120px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.BookingInfo")))
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BusinessNo") } },
                    [
                      _c("el-input", {
                        attrs: {
                          value: _vm.form.jobNo,
                          no: "jobNo",
                          disabled: true
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isZY
                    ? [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.AllowSaleProduct"))
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames
                                    .basic_data_AllowSaleProduct,
                                filterable: "",
                                no: "allowSaleProduct",
                                clearable: "",
                                "data-filter-function": function(p) {
                                  if (!p.statusEnabled) {
                                    return false
                                  }
                                  return _vm.isFba
                                    ? p.fbaRailway
                                    : p.railwayFreight
                                },
                                "default-value": _vm.form.saleProductCode || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.saleProductCode = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.FullOrInside")))]
                            ),
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames
                                    .local_cache_FullOrInside$FULL_OR_INSIDE,
                                no: "fullOrInside",
                                clearable: "",
                                "default-value": _vm.form.fullOrInside || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.fullOrInside = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.containerLoadType")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "containerLoadType" },
                          on: {
                            change: function($event) {
                              _vm.pm.selectDefaultCutomJobType()
                              _vm.onContainerLoadTypeChange()
                            }
                          },
                          model: {
                            value: _vm.form.containerLoadType,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "containerLoadType", $$v)
                            },
                            expression: "form.containerLoadType"
                          }
                        },
                        _vm._l(_vm.containerLoadTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.chineseName, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CargoType,
                          headers: [_vm.$t("Partners.chineseName")],
                          fields: ["chineseName"],
                          "filter-field-names": ["chineseName"],
                          "method-params": { sea: true },
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.cargoType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.cargoType = p.value
                            _vm.onCargoTypeChagne()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("RailwayExport.transportType")))]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transportType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TransportationType,
                          "method-params": {
                            companyLob: "railwayExport",
                            transportType: true,
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.form.transportType,
                          "tag-name":
                            this.$store.getters.language === "zh"
                              ? "chineseName"
                              : "englishName",
                          "tag-value": "code",
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transportType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("RailwayExport.fullHalf")))]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "fullHalf",
                          "select-type":
                            _vm.selectTypeNames.local_cache_FullHalf,
                          filterable: "",
                          "default-value": _vm.form.fullHalf
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.fullHalf = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("RailwayExport.transportLine")))]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transportLine",
                          "select-type":
                            _vm.selectTypeNames.basic_data_RailwayLine,
                          filterable: "",
                          "default-value": _vm.form.transportLine,
                          "tag-name": "name"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transportLine = p.value
                            _vm.pm.refreshPlanner(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("RailwayExport.ETD2")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticClass: "departure-date-picker",
                          staticStyle: {
                            flex: "1",
                            width: "140px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            no: "etd",
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          on: { input: _vm.etdChange },
                          model: {
                            value: _vm.form.etd,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "etd", $$v)
                            },
                            expression: "form.etd"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.form.sailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.ETA2") } },
                    [
                      _vm.form.lob === "RI"
                        ? _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("RailwayExport.ETA2")) + " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: {
                              flex: "1",
                              width: "140px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              no: "eta",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.etaChange },
                            model: {
                              value: _vm.form.eta,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "eta", $$v)
                              },
                              expression: "form.eta"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.form.etaSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ]
                  ),
                  _c("el-form-item", [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("RailwayExport.ATD2")))
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: {
                            flex: "1",
                            width: "140px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            no: "atd",
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            clearable: ""
                          },
                          on: { input: _vm.atdChange },
                          model: {
                            value: _vm.form.atd,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "atd", $$v)
                            },
                            expression: "form.atd"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.form.atdSailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("el-form-item", [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("RailwayExport.ATA2")))
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: {
                            flex: "1",
                            width: "140px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            no: "ata",
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            clearable: ""
                          },
                          on: { input: _vm.ataChange },
                          model: {
                            value: _vm.form.ata,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "ata", $$v)
                            },
                            expression: "form.ata"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.form.ataSailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationDate") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "customsDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.customsDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customsDate", $$v)
                          },
                          expression: "form.customsDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("RailwayExport.departureStation")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "departureStation",
                            "select-type":
                              _vm.selectTypeNames.basic_data_RailwayStation,
                            filterable: "",
                            "default-value": _vm.form.departureStation
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.departureStation = p.value
                              _vm.onDepartureStationChange()
                            }
                          }
                        }),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: {
                              width: "80px",
                              "padding-left": "5px"
                            },
                            attrs: { no: "transfer" },
                            model: {
                              value: _vm.form.transfer,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "transfer", $$v)
                              },
                              expression: "form.transfer"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.transfer,
                          expression: "form.transfer"
                        }
                      ]
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("RailwayExport.transferStation"))
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transferStation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_RailwayStation,
                          filterable: "",
                          "default-value": _vm.form.transferStation
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transferStation = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("RailwayExport.transitStation")))]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transitStation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_RailwayStation,
                          filterable: "",
                          "default-value": _vm.form.transitStation
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transitStation = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("RailwayExport.destinationStation"))
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "destinationStation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_RailwayStation,
                          filterable: "",
                          "default-value": _vm.form.destinationStation
                        },
                        on: { parentCallBack: _vm.destinationStationChange }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.destinationCountry")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "destinationCountry",
                          "select-type": _vm.selectTypeNames.basic_data_Country,
                          filterable: "",
                          "default-value": _vm.form.destinationCountry
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.destinationCountry = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SolicitationType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "cargoSource",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            clearable: false,
                            size: "mini"
                          },
                          on: {
                            change: function($event) {
                              _vm.form.designationAgent = 0
                              _vm.pm.cargoSourceChange()
                            }
                          },
                          model: {
                            value: _vm.form.cargoSource,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoSource", $$v)
                            },
                            expression: "form.cargoSource"
                          }
                        },
                        _vm._l(_vm.CARGO_SOURCES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.chineseName, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                    [
                      _vm.form.lob === "RE"
                        ? _c("cargo-advance-select", {
                            key: "1",
                            ref: "customJobType",
                            attrs: {
                              no: "customJobType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              filterable: "",
                              "default-value": _vm.form.customJobType,
                              "tag-name": _vm.isZh ? "name" : "englishName",
                              "static-options": _vm.customJobTypeList,
                              "method-params": { type: _vm.form.lob }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.customJobType = p.value
                                _vm.onCustomJobTypeChange()
                              }
                            }
                          })
                        : _vm.form.lob === "RI"
                        ? _c("cargo-advance-select", {
                            key: "2",
                            ref: "customJobType",
                            attrs: {
                              no: "customJobType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              filterable: "",
                              "tag-name": _vm.isZh ? "name" : "englishName",
                              "static-options": _vm.customJobTypeList,
                              "method-params": { type: _vm.form.lob },
                              "default-value": _vm.form.customJobType
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.customJobType = p.value
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.form.customJobType &&
                  _vm.secondaryCustomJobTypeList.length > 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Grade") } },
                        [
                          _c("cargo-advance-select", {
                            ref: "secondaryCustomJobType",
                            attrs: {
                              no: "secondaryCustomJobType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              filterable: "",
                              cache: false,
                              "default-value": _vm.form.secondaryCustomJobType,
                              "tag-name": _vm.isZh ? "name" : "englishName",
                              "static-options": _vm.secondaryCustomJobTypeList
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.secondaryCustomJobType = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BookingAgent") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "bookingAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            companyLob: "railwayExport",
                            bookingAgent: true,
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.form.bookingAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.bookingAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.portAgent") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "portAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            companyLob: "railwayExport",
                            portAgent: true,
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.form.portAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.portAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("RailwayExport.forwardingAgent") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "forwardingAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            companyLob: "railwayExport",
                            forwardingAgent: true,
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.form.forwardingAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.forwardingAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("queryJob.destinationAgent") } },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.destinationAgentTip,
                            disabled: !_vm.showDestinationAgentWarning,
                            placement: "right-end"
                          }
                        },
                        [
                          _c("cargo-company-select", {
                            ref: "destinationAgent",
                            attrs: {
                              no: "destinationAgent",
                              "method-params": {
                                overseaAgent: true,
                                active: true,
                                companyLob: "railwayExport"
                              },
                              "check-credit": true,
                              job: _vm.form,
                              "default-value": _vm.form.destinationAgent || "",
                              filterable: "",
                              headers: [_vm.$t("Partners.englishName")],
                              fields: ["englishName"],
                              "tag-name": "englishName"
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.txtDestinationAgentChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.cargoSource === "NC",
                          expression: "form.cargoSource==='NC'"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.NominatedAgent") }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("SeaExport.NominatedAgent")) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.designationAgentTip,
                            disabled: !_vm.showDesignationAgentWarning,
                            placement: "right-end"
                          }
                        },
                        [
                          _c("cargo-company-select", {
                            staticClass: "designation-agent-selector",
                            staticStyle: { width: "190px" },
                            attrs: {
                              no: "designationAgent",
                              "popper-class":
                                "designation-agent-selector-popper",
                              disabled: !_vm.designationAgentEnabled,
                              "method-params": {
                                designationAgent: true,
                                active: true
                              },
                              "check-credit": true,
                              job: _vm.form,
                              "default-value": _vm.form.designationAgent || "",
                              filterable: "",
                              headers: [_vm.$t("Partners.englishName")],
                              fields: ["englishName"],
                              "tag-name": "englishName"
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.txtDesignationAgentChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_TransportSource") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TransportSource,
                          no: "transportSource",
                          "default-value": _vm.form.transportSource,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.form.transportSource = item.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ServiceStatisticalArea")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_StatisticArea,
                          no: "statisticArea",
                          "default-value": _vm.form.statisticArea,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.form.statisticArea = item.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("RailwayExport.ServiceChannel")
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.fbaJob.serviceChannel,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "serviceChannel", $$v)
                              },
                              expression: "fbaJob.serviceChannel"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "110px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.AdditionalInformation")))
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.LocalService") } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "warehousing" },
                          on: {
                            change: function($event) {
                              return _vm.pm.loadingTermChange("warehousing")
                            }
                          },
                          model: {
                            value: _vm.form.warehousing,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "warehousing", $$v)
                            },
                            expression: "form.warehousing"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.WarehouseLoadingStorage"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "landTransportation" },
                          on: {
                            change: function($event) {
                              return _vm.pm.loadingTermChange(
                                "landTransportation"
                              )
                            }
                          },
                          model: {
                            value: _vm.form.landTransportation,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "landTransportation", $$v)
                            },
                            expression: "form.landTransportation"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.DoorLoadingDelivery"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "selfDeliver" },
                          model: {
                            value: _vm.form.selfDeliver,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "selfDeliver", $$v)
                            },
                            expression: "form.selfDeliver"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SeaExport.NotResponsibleForTruckingAndLoading"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm.isBookingNew && _vm.form.destinationPortService
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfDestinationServices")
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "dischargingPortDoor" },
                              model: {
                                value: _vm.form.dischargingPortDoor,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "dischargingPortDoor", $$v)
                                },
                                expression: "form.dischargingPortDoor"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.DispatchVehiclesAtDestination"
                                  )
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "usCustomsClearance" },
                              model: {
                                value: _vm.form.usCustomsClearance,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "usCustomsClearance", $$v)
                                },
                                expression: "form.usCustomsClearance"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("queryJob.UsCustomsClearance")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.WarehouseNo") } },
                        [
                          _c("el-input", {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { no: "warehouseNo" },
                            model: {
                              value: _vm.form.warehouseNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "warehouseNo", $$v)
                              },
                              expression: "form.warehouseNo"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "padding-left": "13px",
                                "padding-right": "13px"
                              },
                              attrs: {
                                disabled: true,
                                no: "ObtainTheWarehouseNo",
                                type: "primary"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.ObtainTheWarehouseNo"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("RailwayExport.paymentMethod")))]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "paymentMethod",
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentMethod,
                          "method-params": {
                            companyLob: "railwayExport",
                            paymentMethod: true,
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.form.paymentMethod,
                          "tag-name":
                            this.$store.getters.language === "zh"
                              ? "chineseName"
                              : "englishName",
                          "tag-value": "code",
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.paymentMethod = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.mbl") } },
                    [
                      _c("el-input", {
                        attrs: { no: "mbl" },
                        model: {
                          value: _vm.form.mbl,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "mbl", $$v)
                          },
                          expression: "form.mbl"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.vessel") } },
                    [
                      _c("el-input", {
                        attrs: { no: "vessel" },
                        model: {
                          value: _vm.form.vessel,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "vessel", $$v)
                          },
                          expression: "form.vessel"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.voyageFlight") } },
                    [
                      _c("el-input", {
                        attrs: { no: "voyageFlight" },
                        model: {
                          value: _vm.form.voyageFlight,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "voyageFlight", $$v)
                          },
                          expression: "form.voyageFlight"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.BusinessReferenceNo") }
                    },
                    [
                      _c("cargo-input", {
                        attrs: { no: "customerRefNo", trim: true },
                        model: {
                          value: _vm.form.customerRefNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customerRefNo", $$v)
                          },
                          expression: "form.customerRefNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      class: _vm.poNoRed ? "poNoClass" : "",
                      attrs: { label: _vm.$t("SeaExport.ItemNo") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "poNo" },
                        model: {
                          value: _vm.form.poNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "poNo", $$v)
                          },
                          expression: "form.poNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomsBroker") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "190px" },
                        attrs: {
                          no: "customsBroker",
                          disabled: !_vm.customsBrokerEnabled,
                          "method-params": { customsBroker: true },
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "data-filter-function": _vm.customsBrokerFilter,
                          filterable: "",
                          "default-value": _vm.form.customsBroker || "",
                          placeholder: _vm.form.customs
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t(
                                "SeaExport.PleaseTickCustomsDeclarationOption"
                              )
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.customsBrokerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomsDeclarationMethod")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethod",
                              disabled: !_vm.customsBrokerEnabled,
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 2 },
                              "tag-value": "serialNum",
                              filterable: "",
                              "default-value": _vm.form.customClaim
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.customClaim = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomsDeclarationType")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsDeclarationType",
                          disabled: !_vm.customsBrokerEnabled,
                          "select-type":
                            _vm.selectTypeNames
                              .basic_data_CustomsDeclarationType,
                          filterable: "",
                          "default-value":
                            _vm.form.customsDeclarationType === -1
                              ? ""
                              : _vm.form.customsDeclarationType,
                          placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customsDeclarationType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TradeMethod") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "tradeTerm",
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TradeTerm,
                          "callback-method-type": "value",
                          "default-value": _vm.form.tradeTerm,
                          "callback-params": { key: "tradeTerm" }
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.tradeTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TradeTerms2") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "incoTerm",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          "callback-method-type": "value",
                          "default-value": _vm.form.incoTerm,
                          "callback-params": { key: "incoTerm" },
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.incoTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.HaulageCompany") } },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "carryingCmp",
                          disabled: !_vm.form.landTransportation,
                          "method-params": { truckCmp: true, active: true },
                          "default-value": _vm.form.carryingCmp || "",
                          placeholder: _vm.form.landTransportation
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t(
                                "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                              )
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.carryingCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Information.TransportationTerms")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "freightTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_ShippingTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.freightTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.freightTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "RailwayExport.EstimatedStoragegoodReadyTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "preWarehousingTime",
                              type: "date",
                              clearable: "",
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.fbaJob.preWarehousingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "preWarehousingTime", $$v)
                              },
                              expression: "fbaJob.preWarehousingTime"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.isFba
                          ? _vm.$t("RailwayExport.DomesticWarehouse")
                          : _vm.openWarehouse
                          ? _vm.$t("SeaExport.WarehouseSupplier")
                          : _vm.$t("SeaExport.Warehouse")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "warehouseCmp",
                          disabled: !_vm.warehouseEabled,
                          "method-params": { warehouse: true, active: true },
                          "default-value": _vm.form.warehouseCmp || "",
                          placeholder: _vm.form.warehousing
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("SeaExport.PleaseSelectWarehouse")
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.warehouseCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.openWarehouse && !_vm.isFba
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.WareHouseName") } },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "warehouseName",
                              attrs: {
                                no: "warehouseName",
                                disabled:
                                  !_vm.warehouseEabled ||
                                  !_vm.form.warehouseCmp,
                                "allow-create": true,
                                filterable: "",
                                clearable: true
                              },
                              on: { change: _vm.warehouseNameChangeHandler },
                              model: {
                                value: _vm.form.warehouseName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "warehouseName", $$v)
                                },
                                expression: "form.warehouseName"
                              }
                            },
                            _vm._l(_vm.warehouseNameList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.warehouseName,
                                  value: item.warehouseName
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("RailwayExport.OverseasWarehouse")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "overseaWarehouseCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_OverseaWarehouse,
                              filterable: "",
                              "method-params": { ifFba: false },
                              clearable: false,
                              "tag-name": "countryChineseName",
                              "tag-value": "warehouseCode",
                              "default-value": _vm.form.overseaWarehouseCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.overseaWarehouseCode = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "RailwayExport.CustomsDeclarationMethod"
                            )
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethodPol",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 0 },
                              filterable: "",
                              clearable: false,
                              "default-value": _vm.fbaJob.customsMethodPol
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.customsMethodPol = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "RailwayExport.CustomsClearanceMethod"
                            )
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethodPod",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 1 },
                              filterable: "",
                              clearable: false,
                              "default-value": _vm.fbaJob.customsMethodPod
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.customsMethodPod = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "diffPlacesCollaborate" },
                      model: {
                        value: _vm.form.diffPlacesCollaborate,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "diffPlacesCollaborate", $$v)
                        },
                        expression: "form.diffPlacesCollaborate"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("RailwayExport.isDiffPlacesCollaborate"))
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.loadingPlaceCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "loadingPlaceCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            loadingPlaceCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.loadingPlaceCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.loadingPlaceCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.signBillPlaceCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "signBillPlaceCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            signBillPlaceCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.signBillPlaceCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.signBillPlaceCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.form.fullShipment,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fullShipment", $$v)
                        },
                        expression: "form.fullShipment"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("RailwayExport.isFullShipment")))]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.dischargePortCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "dischargePortCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            dischargePortCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.dischargePortCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dischargePortCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.destinationPortCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "destinationPortCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            destinationPortCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.destinationPortCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.destinationPortCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "100px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo2")))
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c("booking-sea-eq-data-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          value: _vm.seaEqList,
                          "container-load-type": _vm.form.containerLoadType,
                          "hide-soc": true,
                          "is-edit": _vm.isEdit,
                          job: _vm.form
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.QuantityConsignActual")
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "quantityContract",
                              precision: 0,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                _vm.SEUtils.changeQWCRule(function() {
                                  _vm.form.quantityActual =
                                    _vm.form.quantityContract
                                })
                              }
                            },
                            model: {
                              value: _vm.form.quantityContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantityContract", $$v)
                              },
                              expression: "form.quantityContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            attrs: {
                              no: "quantityActual",
                              precision: 0,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                _vm.SEUtils.changeQWCRule(null, function() {
                                  _vm.form.quantityContract =
                                    _vm.form.quantityActual
                                })
                              }
                            },
                            model: {
                              value: _vm.form.quantityActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantityActual", $$v)
                              },
                              expression: "form.quantityActual"
                            }
                          }),
                          _c("span", [_vm._v("PCS")])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.WeightConsignActual") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "weightContract",
                              precision: 3,
                              min: 0
                            },
                            on: { change: _vm.weightContractChange },
                            model: {
                              value: _vm.form.weightContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weightContract", $$v)
                              },
                              expression: "form.weightContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            attrs: { no: "weightActual", precision: 3, min: 0 },
                            on: { change: _vm.weightActualChange },
                            model: {
                              value: _vm.form.weightActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weightActual", $$v)
                              },
                              expression: "form.weightActual"
                            }
                          }),
                          _c("span", [_vm._v("KGS")])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.CubageConsignActual") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "cubageContract",
                              precision: 3,
                              disabled: !_vm.cubageActualEnabled,
                              min: 0
                            },
                            on: { change: _vm.cubageContractChange },
                            model: {
                              value: _vm.form.cubageContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubageContract", $$v)
                              },
                              expression: "form.cubageContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            ref: "cubageActual",
                            attrs: { no: "cubageActual", precision: 3, min: 0 },
                            on: { change: _vm.cubageActualChange },
                            model: {
                              value: _vm.form.cubageActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubageActual", $$v)
                              },
                              expression: "form.cubageActual"
                            }
                          }),
                          _c("span", [_vm._v("CBM")])
                        ],
                        1
                      )
                    ]
                  ),
                  _vm.isFba
                    ? _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-around"
                            }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: {
                                  "margin-right": "10px",
                                  "margin-left": "20px"
                                },
                                model: {
                                  value: _vm.fbaJob.electric,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "electric", $$v)
                                  },
                                  expression: "fbaJob.electric"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("RailwayExport.WithBattery"))
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                model: {
                                  value: _vm.fbaJob.magnetic,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "magnetic", $$v)
                                  },
                                  expression: "fbaJob.magnetic"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("RailwayExport.WithMagnet"))
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                model: {
                                  value: _vm.fbaJob.powdery,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "powdery", $$v)
                                  },
                                  expression: "fbaJob.powdery"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("RailwayExport.Powder")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                model: {
                                  value: _vm.fbaJob.liquid,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "liquid", $$v)
                                  },
                                  expression: "fbaJob.liquid"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("RailwayExport.Liquid")))]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Package") } },
                    [
                      _c("cargo-packing-select", {
                        ref: "packing",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "packing",
                          "default-value": _vm.form.packing
                        },
                        on: {
                          change: function(p) {
                            _vm.form.packing = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.ChineseDescriptionOfGoods")
                              )
                            )
                          ]),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              attrs: { no: "MergingTickets", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.pm.mergeLclCargoDocInfo(
                                    "cargoChineseName",
                                    _vm.form
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.MergingTickets")))]
                          )
                        ],
                        1
                      ),
                      _c("cargo-rich-textarea", {
                        class:
                          _vm.form.cargoChineseNameWarning === 1
                            ? "red-border"
                            : "",
                        staticStyle: { height: "70px", "min-height": "70px" },
                        attrs: {
                          no: "cargoChineseName",
                          disabled: _vm.readonly,
                          "auto-half-word": false,
                          "text-chars": 0
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                              _vm.form.cargoChineseName,
                              true,
                              function(val) {
                                _vm.form.cargoChineseName = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.cargoChineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cargoChineseName", $$v)
                          },
                          expression: "form.cargoChineseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                              )
                            )
                          ]),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              attrs: { no: "MergingTickets2", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.pm.mergeLclCargoDocInfo(
                                    "cargoEnglishName",
                                    _vm.form
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.MergingTickets")))]
                          )
                        ],
                        1
                      ),
                      _c("cargo-rich-textarea", {
                        class:
                          _vm.form.cargoEnglishNameWarning === 1
                            ? "red-border"
                            : "",
                        staticStyle: { height: "70px", "min-height": "70px" },
                        attrs: {
                          no: "cargoEnglishName",
                          disabled: _vm.readonly,
                          "text-chars": 0,
                          "auto-uppercase": _vm.isUppercaseByConfig
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                              _vm.form.cargoEnglishName,
                              _vm.isUppercaseByConfig,
                              function(val) {
                                _vm.form.cargoEnglishName = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.cargoEnglishName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cargoEnglishName", $$v)
                          },
                          expression: "form.cargoEnglishName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("SeaExport.Marks")))
                          ]),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              attrs: { no: "MergingTickets3", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.pm.mergeLclCargoDocInfo(
                                    "mark",
                                    _vm.form
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.MergingTickets")))]
                          )
                        ],
                        1
                      ),
                      _c("cargo-rich-textarea", {
                        staticStyle: { height: "70px", "min-height": "70px" },
                        attrs: {
                          no: "mark",
                          disabled: _vm.readonly,
                          "text-chars": 0,
                          "auto-uppercase": _vm.isUppercaseByConfig
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Marks"),
                              _vm.form.mark,
                              _vm.isUppercaseByConfig,
                              function(val) {
                                _vm.form.mark = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.mark,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "mark", $$v)
                          },
                          expression: "form.mark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "100px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.OperationInfo")))
                  ]),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.SalesCompany")))
                      ]),
                      _c("el-input", {
                        attrs: {
                          value: _vm.txtSalesOffice,
                          no: "txtSalesOffice",
                          disabled: true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.Sales")))
                      ]),
                      _c("cargo-user-select", {
                        ref: "sales",
                        attrs: {
                          no: "sales",
                          disbled:
                            !_vm.canChangeSalesOfJob ||
                            _vm.pm.isWithinCloseAccountDate,
                          "method-params": {
                            officeId: _vm.salesOfficeCheck
                              ? _vm.$store.getters.currentOfficeId
                              : "",
                            category: "role",
                            shape: "sales"
                          },
                          "default-value": _vm.form.sales || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.txtSalesChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "cargoSalesId",
                          "method-params": {
                            category: "role",
                            shape: "salesOfGoods"
                          },
                          "default-value": _vm.form.cargoSalesId || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.form.cargoSalesId = p.value
                            _vm.pm.cargoSalesChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.SalesDepartment")))
                      ]),
                      _c("cargo-department-new-select", {
                        attrs: {
                          no: "salesOffice",
                          disabled: !_vm.form.sales,
                          enables: true,
                          "sales-id": Number(_vm.form.sales),
                          "office-id": _vm.form.salesOffice,
                          "department-id": Number(_vm.form.salesDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.departmentChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationCompany") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "opOffice",
                          disabled:
                            (!_vm.isRegionalCommission &&
                              _vm.pm.isEntrustOrder(true)) ||
                            _vm.opOfficeDisabled,
                          "is-regional-commission": _vm.isRegionalCommission,
                          "office-id": Number(_vm.form.opOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opOffice = p.value
                            _vm.form.opDepartment = 0
                            _vm.opOfficeChargeHandler()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.OperationDepartment"))
                          )
                        ]
                      ),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "opDepartment",
                          disabled: _vm.pm.isWithinCloseAccountDate,
                          "office-id": Number(_vm.form.opOffice),
                          enables: true,
                          "department-id": Number(_vm.form.opDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))]
                      ),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "op",
                          disabled: !_vm.opEabled,
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.form.op || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.txtOPChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "csrOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.csrOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrOffice = p.value
                            _vm.form.csrDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("Message.Customer_Service")))
                      ]),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "csrDepartment",
                          "office-id": Number(_vm.form.csrOffice),
                          enables: true,
                          "department-id": Number(_vm.form.csrDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerService") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "csr",
                          "method-params": {
                            officeId:
                              _vm.pm.isEntrustOrder || _vm.fom.salesOffice === 1
                                ? _vm.form.opOffice
                                : _vm.form.salesOffice,
                            category: "role",
                            shape: "csr"
                          },
                          "default-value": _vm.form.csr || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FieldOperation") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "siteOp"
                          },
                          "default-value": _vm.form.siteOP || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.JobUtils.siteOpChangeHandler(_vm.form, p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.OverseaCustomerService")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "overseaOp",
                          "method-params": {
                            category: "role",
                            shape: "overseaOp"
                          },
                          "default-value": _vm.form.overseaOp || "",
                          "static-options": _vm.isHC ? null : _vm.overseaOpList,
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.overseaOpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DocumentOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "dcOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.dcOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcOffice = p.value
                            _vm.form.dcDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("Message.Documentation_Department"))
                        )
                      ]),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "dcDepartment",
                          "office-id": Number(_vm.form.dcOffice),
                          enables: true,
                          "department-id": Number(_vm.form.dcDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Documents") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "dc",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "doc"
                          },
                          "default-value": _vm.form.dc || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.dcChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.plannerOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "plannerOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.plannerOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.plannerOffice = p.value
                            _vm.form.plannerDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("RailwayExport.plannerDepartment"))
                        )
                      ]),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "plannerDepartment",
                          "office-id": Number(_vm.form.plannerOffice),
                          enables: true,
                          "department-id": Number(_vm.form.plannerDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.plannerDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.planner") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "planner",
                          "method-params": {
                            category: "role",
                            shape: "railwayLine"
                          },
                          "default-value": _vm.form.planner || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.txtPlannerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId1",
                        attrs: {
                          no: "userDefinedRoleId1",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.form.userDefinedRoleId1 || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId1Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId2",
                        attrs: {
                          no: "userDefinedRoleId2",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.form.userDefinedRoleId2 || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId2Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.WarehousingInfo") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "txtWhs",
                          disabled: true,
                          type: "textarea",
                          rows: 4,
                          value: _vm.txtWhs
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                    [
                      _c("el-input", {
                        attrs: { no: "remarks", type: "textarea", rows: 4 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Remarks"),
                              _vm.form.remarks,
                              false,
                              function(val) {
                                _vm.form.remarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remarks", $$v)
                          },
                          expression: "form.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "100px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.UserDefinedArea")))
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField1") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField1",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField1", $$v)
                          },
                          expression: "form.userDefinedField1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField2") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField2",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.userDefinedField2,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField2", $$v)
                          },
                          expression: "form.userDefinedField2"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField3") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField3",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.userDefinedField3,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField3", $$v)
                          },
                          expression: "form.userDefinedField3"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField4") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField4",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.userDefinedField4,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField4", $$v)
                          },
                          expression: "form.userDefinedField4"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "taxNature",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.form.taxNature,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "taxNature", $$v)
                            },
                            expression: "form.taxNature"
                          }
                        },
                        _vm._l(_vm.TAX_NATURES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          {
            staticClass: "form-card-wrapper",
            staticStyle: {
              display: "flex",
              "flex-direction": "row",
              width: "100%"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "section form-column",
                staticStyle: { flex: "1" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.TicketsInfo")))
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-start",
                      "margin-bottom": "5px",
                      "line-height": "28px"
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("SeaExport.TotalTickets")) + ":")
                    ]),
                    _c("span", { staticStyle: { "margin-right": "5px" } }, [
                      _vm._v(_vm._s(_vm.lclSlaves.length))
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.readonly &&
                              _vm.viewSource === "bookingWorkspace",
                            expression:
                              "readonly&&viewSource==='bookingWorkspace'"
                          }
                        ],
                        staticClass: "triggers"
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "NewTickets",
                              disabled:
                                _vm.viewSource === "financeDetail" ||
                                _vm.viewSource === "salesDetail",
                              type: "primary"
                            },
                            on: { click: _vm.btnCreateClickHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.NewTickets")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "EditTickets",
                              disabled:
                                !_vm.selectedRow ||
                                _vm.viewSource === "financeDetail" ||
                                _vm.viewSource === "salesDetail",
                              type: "primary"
                            },
                            on: { click: _vm.btnLcLEditClickHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.EditTickets")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "AddTickets",
                              disabled:
                                _vm.viewSource === "financeDetail" ||
                                _vm.viewSource === "salesDetail",
                              type: "primary"
                            },
                            on: { click: _vm.btnImportLclClickHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.AddTickets")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "RemoveTickets",
                              disabled:
                                !_vm.selectedRow ||
                                _vm.viewSource === "financeDetail" ||
                                _vm.viewSource === "salesDetail",
                              type: "danger"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.btnBatchRemoveClickHandler()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.RemoveTickets")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_REBooking_deleteSmallTicket"],
                                expression:
                                  "['button_REBooking_deleteSmallTicket']"
                              }
                            ],
                            attrs: {
                              no: "DeleteTickets",
                              disabled:
                                !_vm.selectedRow ||
                                _vm.viewSource === "financeDetail" ||
                                _vm.viewSource === "salesDetail",
                              type: "danger"
                            },
                            on: { click: _vm.btnRemoveClickHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.DeleteTickets")))]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "min-height": "200px",
                      "flex-direction": "column"
                    }
                  },
                  [
                    _c("cargo-ag-grid", {
                      staticStyle: { height: "300px" },
                      attrs: {
                        "config-module": "170003",
                        "grid-options": _vm.gridOptions,
                        "column-defs": _vm.columnDefs,
                        "row-data": _vm.lclSlaves
                      },
                      on: {
                        gridReady: function(params) {
                          _vm.gridApi = params.api
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ]
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceText",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "warning-count": -1,
              "text-chars": 0,
              "auto-uppercase": _vm.advanceTextDialog.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "ticket",
            visible: _vm.ticketDialog.visible,
            title: _vm.$t("SeaExport.FillInQuantityOfVotes"),
            width: "270px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.ticketDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "50px", "label-position": "right" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Number") + "：" } },
                [
                  _c("el-input-number", {
                    attrs: { precision: 0, min: 1, max: 50, controls: false },
                    model: {
                      value: _vm.ticketDialog.value,
                      callback: function($$v) {
                        _vm.$set(_vm.ticketDialog, "value", $$v)
                      },
                      expression: "ticketDialog.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.toAddTicket }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.ticketDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("query-re-lcl-dialog", {
        attrs: { visible: _vm.queryRELclDialog.visible, job: _vm.form },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.queryRELclDialog, "visible", $event)
          },
          callback: function(rows) {
            _vm.pm.slavedAddedHandler(rows)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }